var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTranslateRight = function SvgTranslateRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 42,
    height: 27,
    viewBox: "0 0 99.84 64.14",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.06 38.98a5.888 5.888 0 0 1-5-6.66c.46-3.23 3.45-5.46 6.67-5.01 3.68.53 10.68.36 18.14.18 8.33-.21 17.21-.43 23.65.24 8.4.88 13.58.49 18.99.1 3.88-.28 7.87-.58 13.1-.49-4.29-4.71-8.7-8.52-13.51-12.67l-5.02-4.39a5.872 5.872 0 0 1-.51-8.29 5.875 5.875 0 0 1 8.3-.51l4.94 4.29c6.76 5.84 12.77 11.04 19.08 19.09.49.63 1.19 1.25 1.75 1.76.63.55 1.18 1.04 1.82 1.82 4.46 5.43 3.33 8.41-9.39 18.87-2.73 2.25-5.03 4.27-7.22 6.18-3.63 3.19-6.99 6.14-11.47 9.48-2.61 1.94-6.31 1.41-8.26-1.2-1.94-2.61-1.41-6.31 1.2-8.26 4.45-3.31 7.49-5.98 10.78-8.87 1.95-1.7 3.98-3.49 6.41-5.51-4.37-.04-7.82.21-11.17.46-5.88.43-11.53.84-21.02-.14-5.81-.61-14.25-.4-22.17-.21-8.04.2-15.58.38-20.09-.26z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};

export default SvgTranslateRight;